<template>
    <div class="modal--add-files__details">
        <div class="progress progress--mini">
            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                 :aria-valuenow="file.progress" aria-valuemin="0" aria-valuemax="100" :style="{width: file.progress + '%'}">
                {{file.filename}}
            </div>
        </div>
        <select class="sel sel--small">
            <option value="value1">Simplify 3D</option>
            <option value="value2">Move to project</option>
        </select>
        <select class="sel sel--small">
            <option value="value1">Ultimaker 5</option>
            <option value="value2">Move to project</option>
        </select>
        <b-checkbox>Pack it to ZIP &nbsp;</b-checkbox>
    </div>
</template>

<script>
  export default {
    name: "FilesUploadItem",
    props:['file']
  }
</script>

<style scoped>

</style>
